import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import {
  selectAseActionInAssessment,
  selectAseIsOnline,
} from 'store/assessments/selectors';

import { ScreenSize } from 'lib/constants';
import { useScreenSize } from 'hooks/useScreenSize';
import { useDispatch } from 'react-redux';
import {
  doAseOpenFieldInstance,
  doAseOpenQuestion,
  doAseOpenSection,
} from 'store/actions';
import { ActionDisplay } from './PagesMain/ActionDisplay';
import { ActionEdit } from './PagesMain/ActionEdit';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASSESSMENT],
  Screens.ASE_ACTION
>;

export const ActionScreen: React.FC<Props> = ({ navigation, route }) => {
  const { id, parent, data } = route.params;
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const isOnline = useSelector(selectAseIsOnline);
  const inAssessment = useSelector((state) =>
    selectAseActionInAssessment(state, id),
  );

  const shouldClose = !!id && !inAssessment && !data.isReview;
  React.useEffect(() => {
    if (shouldClose) {
      if (screenSize === ScreenSize.small) {
        navigation?.goBack();
      } else if (data.questionId) {
        dispatch(
          doAseOpenQuestion({
            id: data.questionId,
            fieldInstanceId: data.fieldInstanceId,
            parent,
          }),
        );
      } else if (data.fieldInstanceId) {
        dispatch(
          doAseOpenFieldInstance({
            instanceId: data.fieldInstanceId,
            parent,
            scrollTo: true,
          }),
        );
      } else if (data.sectionId) {
        dispatch(doAseOpenSection({ id: data.sectionId }));
      }
    }
  }, [shouldClose, navigation, parent, data, screenSize, dispatch]);

  if (!isOnline && inAssessment !== false) {
    return (
      <ActionEdit
        route={{ params: { id, parent, data } }}
        navigation={navigation}
      />
    );
  }
  return (
    <ActionDisplay
      route={{ params: { id, parent, data } }}
      navigation={navigation}
    />
  );
};

type PropsR = NativeStackScreenProps<
  NavigationStacks[Stacks.ASEREPEATABLE],
  Screens.ASEREPEATABLE_ACTION
>;

export const ActionRepeatableScreen: React.FC<PropsR> = ({
  navigation,
  route,
}) => {
  const { id, parent, data } = route.params;
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const isOnline = useSelector(selectAseIsOnline);
  const inAssessment = useSelector((state) =>
    selectAseActionInAssessment(state, id),
  );

  const shouldClose = !!id && !inAssessment && !data.isReview;
  React.useEffect(() => {
    if (shouldClose) {
      if (screenSize === ScreenSize.small) {
        navigation?.goBack();
      } else if (data.questionId) {
        dispatch(
          doAseOpenQuestion({
            id: data.questionId,
            fieldInstanceId: data.fieldInstanceId,
            parent,
          }),
        );
      } else if (data.fieldInstanceId) {
        dispatch(
          doAseOpenFieldInstance({
            instanceId: data.fieldInstanceId,
            parent,
            scrollTo: true,
          }),
        );
      } else if (data.sectionId) {
        dispatch(doAseOpenSection({ id: data.sectionId }));
      }
    }
  }, [shouldClose, navigation, parent, data, screenSize, dispatch]);

  if (!isOnline && inAssessment !== false) {
    return (
      <ActionEdit
        route={{ params: { id, parent, data } }}
        navigation={navigation}
      />
    );
  }
  return (
    <ActionDisplay
      route={{ params: { id, parent, data } }}
      navigation={navigation}
    />
  );
};
